import type { RouteId } from '@trello/router';
import { getLocation, getRouteParamsFromPathname } from '@trello/router';

import { navigateToBoardView } from 'app/src/navigateToBoardView';

export const toggleButlerDirectory = async (): Promise<void> => {
  const pathname = getLocation().pathname;
  const params = getRouteParamsFromPathname<RouteId.BOARD>(pathname);
  if (params.view === 'butler') {
    navigateToBoardView({
      routeParams: {
        view: 'board',
      },
      navigateOptions: {
        trigger: true,
      },
    });
  } else {
    navigateToBoardView({
      routeParams: {
        view: 'butler',
      },
      navigateOptions: {
        trigger: true,
      },
    });
  }
};
